<template>
  <div v-bind="attrs">
    <!-- Exibe o LoadingSpinner enquanto isLoading for true -->
    <div v-if="isLoading">
      <LoadingSpinner />
    </div>
    <!-- Exibe o conteúdo somente após o carregamento -->
    <div v-else class="card card-body shadow-sm mt-0">
      <div class="header d-flex justify-content-between align-items-center">
        <h4 class="form-title">
          Detalhes da Prospecção nº {{ prospeccao.id }}
        </h4>
        <button class="btn btn-secondary" @click="voltar">Voltar</button>
      </div>

      <!-- Seção 1: Dados da prospeccao -->
      <div class="form-content mt-3">
        <FormSection title="">
          <p>
            <strong>Por: </strong>
            <span style="color: blue;">{{ prospeccao.usuario }}</span>
          </p>
          <p>
            <strong>Classificação: </strong>
            <span style="color: blue;">{{ prospeccao.classificacao }}</span>
          </p>
          <p>
            <strong>Última ação: </strong>
            <span style="color: blue;">{{ prospeccao.acao }}</span>
          </p>
          <p v-if="prospeccao.data_proximo_contato">
            <strong>Data do próximo contato: </strong>
            <span style="color: blue;">{{ globalUtils.formatarData(prospeccao.data_proximo_contato) }}</span>
          </p>
        </FormSection>
      </div>


      <!-- Seção 2: Dados do responsável -->
      <div class="form-content mt-3">
        <FormSection title="Dados do Responsável">
          <p><strong>Contato:</strong> {{ prospeccao.nome }}</p>
          <p><strong>Data do contato:</strong> {{ globalUtils.formatarData(prospeccao.data_contato) }}</p>
          <p><strong>Forma de contato:</strong> {{ prospeccao.forma_contato }}</p>
          <p><strong>Telefone / WhatsApp:</strong> {{ telefoneProspeccaoFormatado || 'Não informado' }}</p>
          <p><strong>E-mail:</strong> {{ prospeccao.email }}</p>
          <p><strong>Como conheceu a escola:</strong> {{ prospeccao.como_conheceu }}</p>
          <p><strong>Criação:</strong> {{ globalUtils.formatarData(prospeccao.criado_em) }}</p>
          <p><strong>Modificação:</strong> {{ globalUtils.formatarData(prospeccao.atualizado_em) }}</p>
        </FormSection>
      </div>

      <!-- Seção 3: Dados de prospeccao do aluno -->
      <div class="form-content mt-3">
        <FormSection title="Dados de Prospecção do Aluno">
          <p><strong>Nome:</strong> {{ prospeccao.nome_aluno }}</p>
          <p>
            <strong>É ex-aluno?</strong>
            {{ prospeccao.ex_aluno ? 'Sim' : 'Não' }}
          </p>
          <p><strong>Idade:</strong> {{ prospeccao.idade }}</p>
          <p>
            <strong>Possui experiência com cavalo? </strong>
            <span>
              {{ (prospeccao.experiencia_com_cavalo === true || prospeccao.experiencia_com_cavalo === 'true' || prospeccao.experiencia_com_cavalo === 'Sim') ? 'Sim' : 'Não' }}
            </span>
          </p>
          <p v-if="prospeccao.experiencia_com_cavalo === true || prospeccao.experiencia_com_cavalo === 'true' || prospeccao.experiencia_com_cavalo === 'Sim'">
            <strong>Qual?</strong> {{ prospeccao.qual }}
          </p>
          <p><strong>Dia(s) de preferência:</strong> {{ prospeccao.dias_preferencia }}</p>
          <p><strong>Turno(s) de preferência:</strong> {{ prospeccao.turno_preferencia }}</p>
          <p>
            <strong>Observações: </strong>
            <span v-if="prospeccao.observacoes">{{ prospeccao.observacoes }}</span>
            <span v-else class="text-muted">—</span>
          </p>
          
        </FormSection>
      </div>


      <!-- Nova Seção: Dados Financeiros -->
      <div class="form-content mt-3" v-if="financeiro">
        <FormSection title="Dados Financeiros">
          <p>
            <strong>Valor:</strong>
            {{ globalUtils.formatarValor(financeiro.valor) }}
          </p>
          <p>
            <strong>Desconto:</strong>
            {{ globalUtils.formatarPercentual(financeiro.desconto) }}%
          </p>
          <p>
            <strong>Valor com desconto:</strong>
            {{ globalUtils.formatarValor(financeiro.valor - (financeiro.valor * financeiro.desconto / 100)) }}
          </p>
          <p>
            <strong>Forma de pagamento:</strong>
            <!-- Aqui você pode mapear o id para o nome da forma, supondo que tenha uma função ou variável que contenha essas informações -->
            {{ getFormaPagamento(financeiro.forma_pagamento_id) }}
          </p>
          <template v-if="getFormaPagamento(financeiro.forma_pagamento_id) === 'Cheque'">
            <p><strong>Banco nº:</strong> {{ financeiro.banco_numero }}</p>
            <p><strong>Agência:</strong> {{ financeiro.agencia }}</p>
            <p><strong>Cheque nº:</strong> {{ financeiro.cheque_numero }}</p>
          </template>
          <p>
            <strong>Conta financeira:</strong>
            <!-- Exemplo: concatenar apelido, agência e número -->
            {{ getContaFinanceira(financeiro.conta_financeira_id) }}
          </p>
          <p>
            <strong>Data vencimento:</strong>
            {{ globalUtils.formatarData(financeiro.data_vencimento) }}
          </p>
          <p>
            <strong>Data pagamento:</strong>
            {{ globalUtils.formatarData(financeiro.data_pagamento) }}
          </p>
        </FormSection>
      </div>


      <!-- Seção 4: Histórico de interações -->
      <div class="form-content mt-3">
        <FormSection title="Histórico de Interações">
          <template #headerActions>
            <div class="icons-container">
              <!-- Ícone Incluir Interação -->
              <i class="bi bi-plus-circle text-primary mx-2"
                title="Incluir interação"
                @click="handleIncluirInteracao"
                :class="{ 'disabled-icon': disableIcons }"></i>

              <!-- Ícone Realizar Matrícula -->
              <i v-if="hasMatriculaInteracao"
                class="bi bi-check-circle text-success mx-2"
                title="Realizar Matrícula"
                @click="handleRealizarMatricula"
                :class="{ 'disabled-icon': disableIcons }"></i>

              <!-- Mensagem caso o aluno já esteja matriculado -->
              <span v-if="disableIcons" class="text-muted">Aluno matriculado</span>
            </div>
          </template>
          <div class="table-responsive mt-1" v-if="historico && historico.length > 0">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Data da ação</th>
                  <!-- <th>Classificação</th> -->
                  <th>Ação</th>
                  <th>Registrado em</th>
                  <th>Por</th>
                  <th>Motivo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in historico" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ globalUtils.formatarData(item.data_acao) }}</td>
                  <!-- <td>{{ item.classificacao }}</td> -->
                  <td>{{ item.acao }}</td>
                  <td>{{ globalUtils.formatarData(item.criado_em) }}</td>
                  <td>{{ item.usuario }}</td>
                  <td>{{ item.motivo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <p>Nenhum histórico de interação registrado.</p>
          </div>
        </FormSection>
      </div>
    </div>
  </div>

  <IncluirInteracao
    v-if="exibirModalIncluirInteracao && prospeccao.id"
    :id="prospeccao.id"
    :usuario="prospeccao.usuario"
    :ultima-classificacao="ultimaClassificacaoProp"
    :ultima-acao="ultimaAcaoProp"
    :ultima-data-aula="ultimaDataAulaProp"
    :ultima-turma-nome="ultimaTurmaNomeProp"
    :ultima-nivel="ultimaNivelProp"
    :nome_aluno="prospeccao.nome_aluno"
    @fechar="exibirModalIncluirInteracao = false"
    @salvou="handleSalvouInteracao"
  />

</template>

<script>
import { reactive, ref, onMounted, computed, nextTick, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";
import globalUtils from "@/utils/globalUtils.js";
import IncluirInteracao from '@/components/modals/incluirInteracao.vue';

export default {
  components: {
    FormSection,
    IncluirInteracao,
  },

  name: 'DetalharProspeccao',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },

  setup(props, { attrs }) {
    const router = useRouter();
    const route = useRoute();
    const isLoading = ref(true);

    const formasPagamento = ref([]);
    const contasFinanceiras = ref([]);

    // Objeto prospeccao com os campos necessários
    const prospeccao = reactive({
      id: null,
      usuario: "",
      classificacao: "",
      acao: "",
      data_acao: "",
      data_proximo_contato: "",
      // Dados do responsável
      nome: "",
      data_contato: "",
      forma_contato: "",
      telefone_ddi: "+55",
      telefone: "",
      email: "",
      como_conheceu: "",
      criado_em: "",
      atualizado_em: "",
      // Dados do aluno
      nome_aluno: "",
      ex_aluno: false,
      idade: null,
      experiencia_com_cavalo: false,
      qual: "",
      dias_preferencia: "",
      turno_preferencia: "",
      observacoes: "",
    });
    
    // Histórico de interações
    const historico = ref([]);


    // O backend já entrega o histórico ordenado por criado_em DESC,
    // então o primeiro item é o mais recente.
    const lastHistorico = computed(() => historico.value?.[0] || null)

    // Sempre priorize o último histórico; se não houver, caia para os campos da prospecção
    const ultimaClassificacaoProp = computed(() =>
      lastHistorico.value?.classificacao || prospeccao.classificacao || ''
    )
    const ultimaAcaoProp = computed(() =>
      lastHistorico.value?.acao || prospeccao.acao || ''
    )
    const ultimaDataAulaProp = computed(() =>
      lastHistorico.value?.data_aula_experimental || ''
    )
    const ultimaTurmaNomeProp = computed(() =>
      lastHistorico.value?.turma_nome || ''
    )
    const ultimaNivelProp = computed(() =>
      lastHistorico.value?.nivel_nome || ''
    )

    const telefoneProspeccaoFormatado = computed(() =>
      formatarTelefoneComDdi(prospeccao.telefone, prospeccao.telefone_ddi)
    )

    function formatarTelefoneComDdi(numero, ddi = '') {
      const n = String(numero || '').trim();
      if (!n) return '';
      if (/^\+\d/.test(n)) return n;

      const d = String(ddi || '').trim();
      if (!d) return n;

      return `${d} ${n}`.trim();
    }



    // Função para carregar os dados da API
    const carregarDados = async () => {
      try {
        const id = route.params.id;
        if (!id) return;
        // Busca os dados da prospeccao
        const responseProspeccao = await axios.get(`/operacional/prospeccao/${id}`);
        Object.assign(prospeccao, responseProspeccao.data);
        // Busca o histórico de interações
        const responseHistorico = await axios.get(`/operacional/prospeccao/${id}/historico`);
        historico.value = responseHistorico.data;
      } catch (error) {
        console.error("Erro ao carregar dados da prospeccao:", error);
      } finally {
        isLoading.value = false;
      }
    };

    // Variável para dados financeiros
    const financeiro = ref(null);

    // Função para carregar os dados financeiros
    const carregarFinanceiro = async () => {
      try {
        const id = route.params.id; // Use o id da rota
        const response = await axios.get(`/operacional/prospeccao/${id}/financeiro`);
        financeiro.value = response.data;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          financeiro.value = null;
        } else {
          console.error("Erro ao carregar dados financeiros:", error);
        }
      }
    };

    // Função para carregar as formas de pagamento
    const carregarFormasPagamento = async () => {
      try {
        const response = await axios.get('/cadastros/formas-pagamento');
        formasPagamento.value = response.data.data || response.data;
      } catch (error) {
        console.error("Erro ao carregar formas de pagamento:", error);
      }
    };

    // Função para carregar as contas financeiras
    const carregarContasFinanceiras = async () => {
      try {
        const response = await axios.get('/financeiro/contas-financeiras');
        contasFinanceiras.value = response.data.data || response.data;
      } catch (error) {
        console.error("Erro ao carregar contas financeiras:", error);
      }
    };

    // Função para retornar o nome da forma de pagamento, com base no id
    const getFormaPagamento = (formaId) => {
      const forma = formasPagamento.value.find(fp => fp.id === formaId);
      return forma ? forma.nome : '';
    };

    // Função para retornar a concatenação da conta financeira
    const getContaFinanceira = (contaId) => {
      const conta = contasFinanceiras.value.find(c => c.id === contaId);
      return conta ? `${conta.apelido} - ${conta.agencia} - ${conta.numero_conta}` : '';
    };

    // Variável reativa para controle do modal de interação
    const exibirModalIncluirInteracao = ref(false);

    // Função para abrir o modal
    const incluirInteracao = () => {
      exibirModalIncluirInteracao.value = true;
    };

    // Manipulador chamado ao salvar a interação
    const handleSalvouInteracao = async () => {
      exibirModalIncluirInteracao.value = false;
      
      // Aguarda a conclusão de todos os carregamentos
      await carregarDados();
      await carregarFormasPagamento();
      await carregarContasFinanceiras();
      await carregarFinanceiro();

      // Aguarda que as atualizações reativas se propaguem
      await nextTick();

      if (hasMatriculaInteracao.value) {
        handleRealizarMatricula();
      }
    };

    // Computed que verifica se existe uma interação de matrícula no histórico
    const hasMatriculaInteracao = computed(() => {
      return lastHistorico.value && lastHistorico.value.acao === "Matrícula";
    });

    // Função para realizar matrícula
    const realizarMatricula = () => {
      router.push({ name: "CadastrarMatriculas", query: { prospeccaoId: prospeccao.id } });
    };

    const handleIncluirInteracao = () => {
      if (disableIcons.value) {
        return;
      }
      incluirInteracao();
    };

    const handleRealizarMatricula = () => {
      if (disableIcons.value) {
        return;
      }
      realizarMatricula();
    };

    const disableIcons = computed(() => {
      return prospeccao.classificacao === "Matriculado" || historico.value.some(item => item.classificacao === "Matriculado");
    });

    // const lastHistorico = computed(() => {
    //   // Filtra os históricos para a prospeccão atual
    //   const filtrados = historico.value.filter(item => item.prospeccao_id == prospeccao.id);

    //   if (filtrados.length) {
    //     // Ordena em ordem decrescente pelo id (ou pela data de criação, se preferir)
    //     filtrados.sort((a, b) => b.id - a.id);
    //     return filtrados[0];
    //   }
    //   return {};
    // });

    watch(() => lastHistorico.value, () => {
    }, { immediate: true });


    // Navega para a rota de listagem de prospeccoes
    const voltar = () => {
      router.push("/operacional/prospeccao");
    };

    onMounted(async () => {
      await carregarDados();
      carregarFormasPagamento();
      carregarContasFinanceiras();
      carregarFinanceiro();
      // Verifica a query para abertura do modal
      if (route.query.openInteracao === 'true') {
        exibirModalIncluirInteracao.value = true;
      }
      if (route.query.openMatricula === 'true') {
        realizarMatricula();
      }
    });

    return {
      globalUtils,
      isLoading,
      prospeccao,
      historico,
      financeiro,
      incluirInteracao,
      exibirModalIncluirInteracao,
      handleSalvouInteracao,
      voltar,
      attrs,
      formasPagamento,
      contasFinanceiras,
      getFormaPagamento,
      getContaFinanceira,
      hasMatriculaInteracao,
      realizarMatricula,
      handleIncluirInteracao,
      handleRealizarMatricula,
      disableIcons,
      lastHistorico,
      ultimaClassificacaoProp,
      ultimaAcaoProp,
      ultimaDataAulaProp,
      ultimaTurmaNomeProp,
      ultimaNivelProp,
      telefoneProspeccaoFormatado
    };
  },
};
</script>

<style scoped>
.table-responsive {
  max-height: 300px;
  overflow-y: auto;
}
.disabled-icon {
  opacity: 0.5;       /* Deixa o ícone visualmente desativado */
  pointer-events: none; /* Impede cliques */
}

</style>
